import { render, staticRenderFns } from "./ResponsibilityRoleEdit.vue?vue&type=template&id=fb099e18"
import script from "./ResponsibilityRoleEdit.vue?vue&type=script&lang=js"
export * from "./ResponsibilityRoleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports